import { Observable } from 'rxjs'

export default class CitiesService {
  constructor() {
    this.cities$ = new Observable((subscriber) => {
      this.subscriber = subscriber
    })
  }

  getObservableCities() {
    return this.cities$
  }

  getCities(options) {
    if (this.events) this.events.close()
    const url = new URL('cities', window.location.href)

    Object.entries(options).forEach((entry) => {
      const [key, value] = entry
      url.searchParams.append(key, value)
    })

    this.events = new EventSource(url.toString())

    this.events.onmessage = (event) => {
      const cities = JSON.parse(event.data)

      this.subscriber.next(cities)
    }
  }
}
